export default __webpack_public_path__ + "static/media/TotalCalorieBurnt.6bb30b5b.svg";